/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, August 8th 2022, 1:52:25 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import {
  APIMany2OneSelectFormInput,
  APIMany2OneEditButton,
  ConcreteAPIMany2OneSelectFormInputProps,
  useToggleState,
} from "ui-widgets";
import { useOSFormContext } from "ui-widgets/forms/providers";
import { DatasetReference, DatasetReferenceAPIFilters } from "lib/schemas";
import { APISERVICEPATHS } from "lib/api";
import StorageIcon from "@mui/icons-material/Storage";
import { DatasetReferenceForm, DatasetReferenceFormProps } from "./DatasetReferenceForm";

type DatasetReferenceSelectInputProps<TPrimaryObject> = ConcreteAPIMany2OneSelectFormInputProps<
  TPrimaryObject,
  DatasetReference
> &
  Partial<Pick<DatasetReferenceFormProps, "settingsType">>;

export const DatasetReferenceSelectInput = <TPrimaryObject,>(
  props: DatasetReferenceSelectInputProps<TPrimaryObject>
) => {
  const { watch } = useOSFormContext<TPrimaryObject>();
  const datasetReferenceId = watch<any>(props.schema_field_key) as DatasetReference["id"];

  const { open: editFormOpenState, handleClose: closeEditFormFn, handleOpen: openEditFormFn } = useToggleState();

  const referenceTypeFilter: DatasetReferenceAPIFilters =
    props.settingsType === "data_update" ? { reference_type: "update" } : { reference_type: "read" };

  return (
    <>
      <APIMany2OneSelectFormInput<TPrimaryObject, DatasetReference>
        apiServicePath={APISERVICEPATHS.datasetReferences}
        apiQueryParams={referenceTypeFilter}
        itemIdProperty="id"
        label={props.label ?? "Dataset Connection"}
        getOptionLabel={(option) => option.name}
        inputStartAdornment={<StorageIcon color="primary" />}
        inputEndAdornment={<APIMany2OneEditButton objectId={datasetReferenceId} onClick={openEditFormFn} />}
        renderRelatedObjectForm={({ handleCloseForm, formOpenState }) => (
          <DatasetReferenceForm
            open={formOpenState}
            handleClose={handleCloseForm}
            datasetReferenceId={null}
            settingsType={props.settingsType}
          />
        )}
        {...props}
      />
      <DatasetReferenceForm
        open={editFormOpenState}
        handleClose={closeEditFormFn}
        datasetReferenceId={datasetReferenceId}
        settingsType={props.settingsType}
      />
    </>
  );
};
